function favicon(url: string): string {
	const urlObj = new URL(url);
	return `https://s2.googleusercontent.com/s2/favicons?domain_url=${urlObj.origin}`;
}

function extendOptions(defaultOptions: any, currentOptions: any): any {
	const currentOptionsCopy = JSON.parse(JSON.stringify(currentOptions));

	for (const option of Object.keys(defaultOptions)) {
		if (!Object.keys(currentOptionsCopy).includes(option)) {
			currentOptionsCopy[option] = defaultOptions[option];
		}
	}

	return currentOptionsCopy;
}

function copyToClipboard(str: string) {
	const el = document.createElement('textarea');
	el.value = str;
	document.body.appendChild(el);
	el.select();
	document.execCommand('copy');
	document.body.removeChild(el);
}

function convertToCSV(objArray: any) {
	const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
	let str = '';

	for (const arrayElem of array) {
		let line = '';
		for (const index in arrayElem) {
			if (arrayElem.hasOwnProperty(index)) {
				if (line !== '') {
					line += ',';
				}
				line += arrayElem[index];
			}
		}
		str += line + '\r\n';
	}

	return str;
}

function processDataForCopyPaste(data: any): string {
	if (data.length > 1) {
		return convertToCSV(data);
	}
	const dataToCopy = data[0];
	let dataStr = '';

	for (const key in dataToCopy) {
		if (dataToCopy.hasOwnProperty(key)) {
			dataStr += `${key}: ${dataToCopy[key]}\n`;
		}
	}
	return dataStr;
}

function makeRandomString(length: number): string {
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

function getAgoString(dateStr: string): string {
	const date = new Date(dateStr);
	const now = new Date();
	const times = [['second', 1], ['minute', 60], ['hour', 3600], ['day', 86400],
	['week', 604800], ['month', 2592000], ['year', 31536000]];
	// @ts-ignore
	let diff = Math.round((now - date) / 1000);
	for (let t = 0; t < times.length; t++) {
		if (diff < times[t][1]) {
			if (t === 0) {
				return 'Just now';
			} else {
				// @ts-ignore
				diff = Math.round(diff / times[t - 1][1]);
				return diff + ' ' + times[t - 1][0] + (diff === 1 ? ' ago' : 's ago');
			}
		}
	}
	return '';
}

export { 
	favicon, 
	extendOptions, 
	copyToClipboard, 
	convertToCSV, 
	processDataForCopyPaste, 
	makeRandomString, 
	getAgoString 
};
